import MessageBox from '@zoom/zoom-ui/src/components/message-box/message-box';
import ZoomUIMessageBox from '@zoom/zoom-ui/src/components/message-box';
import { isVNode } from "@zoom/zoom-ui/src/utils/vdom";
import merge from "@zoom/zoom-ui/src/utils/merge";
import { EVENT_TYPES, emit } from '@/utils/event-emitter.js';

const BillingMessageBox = function(options, callback) {

  if(typeof options === 'string' || isVNode(options)) {
    return MessageBox(options, callback);
  } else {
    if(!options.title && options.message) {
      options.customClass = options.customClass || 'only-message-message-box';
    } else if(options.title && !options.message) {
      options.customClass = options.customClass || 'only-title-message-box';
    }
    return MessageBox(options, callback);
  }
}

BillingMessageBox.alert = (message, title, options) => {
  if (typeof title === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }

  emit(EVENT_TYPES.UI_GLOBAL_ALERT, {
    type: 'alert',
    message: [title, message].filter((message) => !!message),
  });

  const messageBox = BillingMessageBox(merge({
    title: title,
    message: message,
    $type: 'alert',
    closeOnPressEscape: false,
    closeOnClickModal: false,
  }, options));

  const btns = document.querySelectorAll('.zm-message-box__btns button')
  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      emit(EVENT_TYPES.UI_GLOBAL_ALERT_CLICK_CTA, {
        ctaText: btn.textContent.trim(),
        type: 'alert',
        message: [title, message].filter((message) => !!message)
      });
    }, true);
  });

  return messageBox
};

BillingMessageBox.confirm = (message, title, options) => {
  if (typeof title === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return BillingMessageBox(merge({
    title: title,
    message: message,
    $type: 'confirm',
    showCancelButton: true,
  }, options));
};

BillingMessageBox.prompt = (message, title, options) => {
  if (typeof title === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }
  return BillingMessageBox(merge({
    title: title,
    message: message,
    showCancelButton: true,
    showInput: true,
    $type: 'prompt',
  }, options));
};
BillingMessageBox.install = Vue => {
  ZoomUIMessageBox.install(Vue);
  Vue.prototype.$msgbox = BillingMessageBox;
  Vue.prototype.$alert = BillingMessageBox.alert;
  Vue.prototype.$confirm = BillingMessageBox.confirm;
  Vue.prototype.$prompt = BillingMessageBox.prompt;
}
export default BillingMessageBox;
